import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

const expires = 1000 * 60 * 60 * 24; 

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: expires,
    },
    mutations: {
      onError: (error) => {
        console.log(error);
      },
    },
  },
});

export const QueryProvider: React.FC<Props> = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
